import TemplateConfigurationContent from "./TemplateConfigurationContent";
import ManageRegistration from "./ManageRegistration";
import ManageTicket from "./ManageTicket";
import QueryAnalyzer from "./QueryAnalyzer";
import ExternalDataImport from "./ExternalDataImport";
import PayerImport from "./PayerImport";
import BulkNoteRegenerate from "./BulkNoteRegenerate";
import MenuMaster from "./MenuMaster";
import UserRole from "./UserRole";
import UserManagement from "./UserManagement";
import UserAccountMapping from "./UserAccountMapping";
import UserFeatureAccess from "./UserFeatureAccess";
import BulkSMSPage from "./BulkSMSPage";
import ConfigureIntakeSheet from "./ConfigureIntakeSheet";
import KioskAllowedCompanies from "./KioskAllowedCompanies";
import ConfigureReferralTemplate from "./ConfigureReferralTemplate";
import SupervisingDoctorConfiguration from "./SupervisingDoctorConfiguration";
import ManageAdminUsers from "./ManageAdminUsers";
import QueryAnalyzerLogs from "./QueryAnalyzerLogs";
import GeneralLogs from "./GeneralLogs";
import UserInfo from "./UserInfo";
import ConfigureProviderLogin from "./ConfigureProviderLogin";
import MixPanelLogs from "./MixPanelLogs";
import CompanyManagement from "./CompanyManagement";
import IncorrectJsonNote from "./IncorrectJsonNote";
import RoleDomainMappings from "./RoleDomainMappings";
import AccountRegistration from "./AccountRegistration";
import DMEDataEntryReport from "./Reports/DMEDataEntryReport/DMEDataEntryReport";
import AICheckPostingReport from "./Reports/AICheckPostingReport/AICheckPostingReport";
import AIVerificationSummaryReport from "./Reports/AIVerificationSummaryReport/AIVerificationSummaryReport";
import BillingReport from "./Reports/BillingReport/BillingReport";
import MedicalNoteTemplateUsageReport from "./Reports/MedicalNoteTemplateUsageReport/MedicalNoteTemplateUsageReport";
import EHREventVisitSearchReport from "./Reports/EHREventVisitSearchReport/EHREventVisitSearchReport";
import DocumentGenerationLogsReport from "./Reports/DocumentGenerationLogsReport/DocumentGenerationLogsReport";
import MonthlyElectronicSubmissionReport from "./Reports/MonthlyElectronicSubmissionReport/MonthlyElectronicSubmissionReport";
import MonthlyFaxReport from "./Reports/MonthlyFaxReport/MonthlyFaxReport";
import WeeklyPaymentReport from "./Reports/WeeklyPaymentReport/WeeklyPaymentReport";
import NotificationSettings from "./NotificationSettings";
import MonthlyAttornyTransfersummaryReport from "./Reports/MonthlyAttornyTransfersummaryReport/MonthlyAttornyTransfersummaryReport";

export const componentRegistry = {
  "ManageRegistration": <ManageRegistration />,
  "ManageTicket": <ManageTicket />,
  "QueryAnalyzer": <QueryAnalyzer />,
  "ExternalImport": <ExternalDataImport />,
  "PayerImport": <PayerImport />,
  "ConfigureNewTemplate": <TemplateConfigurationContent activeTab={1} />,
  "DeleteTemplate": <TemplateConfigurationContent activeTab={2} />,
  "TemplateConfiguration": <TemplateConfigurationContent activeTab={3} />,
  "AddNewTemplate": <TemplateConfigurationContent activeTab={4} />,
  "MenuMaster": <MenuMaster />,
  "UserManagement": <UserManagement />,
  "UserAccountMapping": <UserAccountMapping />,
  "BulkNoteRegenerate": <BulkNoteRegenerate />,
  "ConfigureNewFeature":<UserFeatureAccess/>,
  "BulkSMSPage":<BulkSMSPage/>,
  "ConfigureIntakeSheet":<ConfigureIntakeSheet/>,
  "KioskAllowedCompanies":<KioskAllowedCompanies/>,
  "ConfigureReferralTemplate":<ConfigureReferralTemplate/>,
  "ConfigurationSupervisingDoctor":<SupervisingDoctorConfiguration/>,
  "ManageAdminUsers": <ManageAdminUsers />,
  "QueryAnalyzerLogs": <QueryAnalyzerLogs />,
  "GeneralLogs": <GeneralLogs />,
  "UserInfo": <UserInfo />,
  "ConfigureProviderLogin": <ConfigureProviderLogin />,
  "MixPanelLogs":<MixPanelLogs/>,
  "CompanyManagement":<CompanyManagement/>,
  "IncorrectJsonNote":<IncorrectJsonNote/>,
  "RoleDomainMappings":<RoleDomainMappings/>,
  "AccountRegistration":<AccountRegistration/>,
  "DMEDataEntryReport":<DMEDataEntryReport/>,
  "AICheckPostingReport":<AICheckPostingReport/>,
  "AIVerificationSummaryReport":<AIVerificationSummaryReport/>,
  "BillingReport":<BillingReport/>,
  "MedicalNoteTemplateUsageReport": <MedicalNoteTemplateUsageReport />,
  "EHREventVisitSearchReport": <EHREventVisitSearchReport />,
  "DocumentGenerationLogsReport": <DocumentGenerationLogsReport />,
  "MonthlyElectronicSubmissionReport": <MonthlyElectronicSubmissionReport />,
  "MonthlyFaxReport": <MonthlyFaxReport />,
  "WeeklyPaymentReport": <WeeklyPaymentReport />, 
  "NotificationSettings": <NotificationSettings />,
  "MonthlyAttornyTransfersummaryReport": <MonthlyAttornyTransfersummaryReport />,

};